import { defineStore } from 'pinia'
import * as api from '@/api/auth'
import type { User } from '@/types'

export const useUserStore = defineStore('user', {
  state: () => ({
    user: null as User | null,
  }),
  getters: {
    abilities: (state) => !!state.user?.abilities,
  },
  actions: {
    fetch() {
      return api.getMe().then(({ data }) => {
        this.user = data
        return data
      })
    },
  },
  persist: true,
})
